const rolesNames = {
  councelor: 'counselor',
  counselor: 'counselor',
  advisor: 'advisor',
  head: 'head',
}

export default rolesNames
